import React, { useEffect, useState } from 'react';
import ImageLoad from 'components/ImageLoad';
import PropTypes from 'prop-types';
import {useViewportMediaQuery} from 'hooks';
import Link from 'components/Link';
import TagManagerService from 'services/TagManager';
import style from './style.scss';//NOSONAR

const GridImageText = (props) => {
    let tagManager = [];

    const itemData = props.data ? props.data : null;
    if(!(itemData && itemData.image_mobile && itemData.image_desktop && itemData.title)) return ''
    
    const [active, setActive] = useState(false);
    const isMobile = useViewportMediaQuery('768');

    useEffect(() => {
        TagManagerService.promotionsImpressions(tagManager);
    }, [])


    let imageResponsive = {
        840: itemData.image_mobile ? itemData.image_mobile : '',
        1440: itemData.image_desktop ? itemData.image_desktop : ''
    };

    tagManager.push({
        id: itemData.image_desktop  ? itemData.image_desktop : itemData.title,
        name: itemData.title ? itemData.title : itemData.image_desktop ,
        position: 'slot' + itemData.countIslandImgText || '',
        creative: `Vitrina imagen L ${itemData.countIslandImgText || ''} - ${itemData.title || ''}`
    })

    const _open = () => {
        setActive(prevState => !prevState);
        sendGtm();
    }

    const reDirectUrl = () => {
        window.location.href = isMobile ? itemData.url : '';
    }

    const sendGtm = () => {
        const promotionClick = {
            id: itemData.image_desktop  ? itemData.image_desktop : itemData.title,
            name: itemData.title ? itemData.title : itemData.image_desktop ,
            position: 'slot' + itemData.countIslandImgText || '',
            creative: `Vitrina imagen L ${itemData.countIslandImgText || ''} - ${itemData.title || ''}`
        };
        
        TagManagerService.promotionsClick(promotionClick);
    }

    const characterLimit = (itemData.text.length >= 120);

    return (
        <div className="island-image-and-text">
            <h3 className="island-title" >{itemData.title}</h3>

            <div className={"island-text-info-wrap " + (active ? ' open ' : ' close ') + (itemData.dark_or_light ? ' bg-black ' : ' bg-white ') + (characterLimit ? '' : ' character-limit ')}>
                <>
                    <span className="island-text-info-title">{itemData.title}</span>
                    {itemData.text && <p className="island-text-info-description">{itemData.text}</p>}

                    {itemData.url && !isMobile && <div className="island-text-info-button-content">
                        <Link className="island-text-info-button" onClick={sendGtm} to={itemData.url}>Ver más</Link>
                    </div>}
                </>

                {itemData.text && isMobile && characterLimit && <div className="island-wrap-read-more-button">
                    <button className="island-read-more-button" onClick={_open}>{active ? 'Leer menos' : 'Leer más'}</button>
                </div>}
            </div>

            <div className={"island-image-wrap"} onClick={reDirectUrl}>
                <ImageLoad className="island-image" srcSet={imageResponsive} src={itemData.image_desktop ? itemData.image_desktop : ''}/>
            </div>
        </div>
    )
}

GridImageText.propTypes = {
    data: PropTypes.object
}

export default GridImageText;
